import { S3Client } from "@aws-sdk/client-s3";

export const REGION = process.env.REACT_APP_AWS_REGION || 'eu-north-1';
export const BUCKET_NAME = process.env.REACT_APP_S3_BUCKET_NAME || 'vshots';
export const CLOUDFRONT_DOMAIN = process.env.REACT_APP_CLOUDFRONT_DOMAIN || 'd176ikvqfx9vta.cloudfront.net';
export const VIDEO_PREFIX = process.env.REACT_APP_S3_VIDEO_PREFIX || 'video';
export const DATA_FILE_KEY = 'data.json';

export const s3Client = new S3Client({
  region: REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || 'AKIASNYSACZ2QPF676P6',
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY || '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',
  },
  requestChecksumCalculation: "WHEN_REQUIRED",
  responseChecksumValidation: "WHEN_REQUIRED",
});
